import React from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Grid } from '@abyss/web/ui/Grid';
import { Button } from '@abyss/web/ui/Button';
import { Link } from '@abyss/web/ui/Link';
import { Label } from '@abyss/web/ui/Label';
import { styled } from '@abyss/web/tools/styled';
import { Flex } from '@abyss/web/ui/Flex';

const StyledLink = styled(Link, {
  marginLeft: '5px;',
});

export const Login = () => {
  return (
    <React.Fragment>
      <Flex
        justify="center"
        alignItems="center"
        alignContent="center"
        direction="column"
        css={{ margin: '5% 0' }}
      >
        <Grid>
          <Grid.Col span={{ xs: 12 }}>
            <Box
              //padding={20}
              align="center"
              css={{ backgroundColor: 'white',borderRadius: '8px', maxWidth: '460px' }}
              width="100%"
              height="100%"
            >
              <Label fontWeight="$bold" color="$gray7" css={{ fontSize: '1.5em' }}>
                Customer Technology Experience
              </Label>
              <Grid>
                  <Grid.Col span={{ xs: 12 }}>
                    <Button
                      css={{ width: '100%', margin: '10% 0'}}
                      onClick={() => {
                        window.location.href = '/sso';
                      }}
                    >
                      Log in with SSO
                    </Button>
                  </Grid.Col>
                </Grid>
            </Box>
          </Grid.Col>
        </Grid>
      </Flex>
    </React.Fragment>
  );
};
